



























































































































































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { LanguageDto } from "@/server/app.dtos";
import ConfigsService from "@/services/api/configs.service";
import {
  GridColumn,
  GridColumnTypes,
  GridAction,
  GridActionEvent,
} from "@/models/grids/column";
import { concatUrls } from "@/utilities/url";
import { Getter } from "vuex-class";
import { NotificationServiceBus } from "@/services/bus/notifications.service";
import SingleFileUploaderComponent from "@/components/uploaders/SingleFileUploader.vue";
import moment from "moment";
declare const Sortable: any;

@Component({
  components: {
    SingleFileUploader: SingleFileUploaderComponent,
  },
})
export default class DataGridComponent extends Vue {
  @Prop({ default: "" }) endpoint!: string;
  @Prop({ default: "/Files" }) folder!: string;
  @Prop({ default: "" }) primary!: string;
  @Prop({ default: () => [] }) columns!: any[];
  @Prop({ default: () => [] }) actions?: any[];
  @Prop({ default: false }) enableReorder?: boolean;
  @Prop({ default: false }) enableEditOnly?: boolean;
  @Prop({ default: true }) enableEdit?: boolean;
  @Prop({ default: false }) enableEditAndDetail?: boolean;
  @Prop({ default: true }) enableLanguages?: boolean;
  @Prop({ default: true }) enableAdd?: boolean;
  @Prop({ default: true }) enableViewDetails?: boolean;
  

  headers: GridColumn[] = [];
  configsService: ConfigsService = new ConfigsService();
  sort: boolean = true;
  paging: boolean = true;
  isLoading: boolean = false;
  isValid: boolean = false;
  items: any[] = [];
  confirmDialog: boolean = false;
  editableDialog: boolean = false;
  createAnother: boolean = false;
  current: any = {};
  calc: string = "-";

  @Getter languages?: LanguageDto[];
  currentLanguage: LanguageDto | null = null;

  @Watch("currentLanguage")
  oncurrentLanguage() {
    this.LoadItems(false);
  }

  get filteredItems(): any[] {
    const filtersToApply = this.headers.filter(
      (f) => f.filterable && f.arg.value
    );
    if (filtersToApply.length > 0) {
      let it = [...this.items];
      filtersToApply.forEach((header) => {
        if (typeof header.arg.value == "object") {
          it = it.filter(
            (s) => s[header.value] == header.arg.value[header.value]
          );
        } else {
          it = it.filter((s) => s[header.value] == header.arg.value);
        }
      });
      return it;
    }
    return this.items;
  }

  get filteredHeaders(): GridColumn[] {
    return this.headers.filter((col: GridColumn) => !col.hidden);
  }

  get isNew() {
    return !this.current || this.current[this.primary] <= 0;
  }

  get editableFields(): GridColumn[] {
    return this.headers.filter((i: GridColumn) => i.editable);
  }

  get hasFilters(): boolean {
    return this.headers.filter((i: GridColumn) => i.filterable).length > 0;
  }

  async created() {
    this.headers = [];
    if (this.enableReorder) {
      this.sort = false;
      this.paging = false;
      this.headers.push({
        value: "_reorder",
        text: "Ordem",
        type: GridColumnTypes.Text,
        editable: false,
      });
    }

    this.headers = this.headers.concat(this.columns);


    if (this.enableEditOnly) {
      this.headers.push({
        value: "_editOnly",
        text: "",
        type: GridColumnTypes.Text,
        editable: false,
        class: "text-right",
      });
    }

    if (this.enableEdit) {
      this.headers.push({
        value: "_edit",
        text: "",
        type: GridColumnTypes.Text,
        editable: false,
        class: "text-right",
      });
    }

    if (this.enableEditAndDetail) {
      this.headers.push({
        value: "_editDetails",
        text: "",
        type: GridColumnTypes.Text,
        editable: false,
        class: "text-right",
      });
    }

    if (this.enableViewDetails) {
      this.headers.push({
        value: "_viewDetails",
        text: "",
        type: GridColumnTypes.Text,
        editable: false,
        class: "text-right",
      });
    }

    if (this.languages && this.languages.length > 0) {
      this.currentLanguage = this.languages[0];
    }

    await this.LoadItems(false);
  }

  showDropdownValue(item: any, field: any) {
    const v = field.arg.items.find(
      (e: any) => e[field.value] == item[field.value]
    );
    return v ? v[field.arg.itemText] : "";
  }

  async LoadItems(ingoreLoadingVariable: boolean) {
    if (!ingoreLoadingVariable && this.isLoading) return;
    this.isLoading = true;
    await this.configsService
      .Load(
        this.endpoint,
        this.currentLanguage
          ? `IdLanguage=${this.currentLanguage.idLanguage}`
          : ""
      )
      .then((result: any) => {
        this.items = result.data ? result.data : result;
      })
      .catch(() => (this.items = []))
      .finally(() => (this.isLoading = false));
  }

  isChips(type: any): boolean {
    return type === GridColumnTypes.Chips;
  }

  isText(type: any): boolean {
    return type === GridColumnTypes.Text;
  }

  isBoolean(type: any): boolean {
    return type === GridColumnTypes.Boolean;
  }

  isContains(type: any): boolean {
    return type === GridColumnTypes.Contains;
  }

  isColor(type: any): boolean {
    return type === GridColumnTypes.Color;
  }

  isDropdown(type: any): boolean {
    return type === GridColumnTypes.Dropdown;
  }

  isFileAny(type: any): boolean {
    return type === GridColumnTypes.FileAny;
  }

  isDate(type: any): boolean {
    return type === GridColumnTypes.Date;
  }

  isDatetime(type: any): boolean {
    return type === GridColumnTypes.DateTime;
  }

  isCalc(type: any): boolean {
    console.log(type);
    return type === GridColumnTypes.Calc;
  }

  formatDate(value: string): string {
    return value
      ? moment(value).format(process.env.VUE_APP_CONFIGS_DATE_FORMAT)
      : "";
  }

  getFilename(value: string): string {
    if (value.indexOf("/") >= 0) {
      const items = value.split("/");
      return items[items.length - 1];
    }
    return "-";
  }

  getFilenameSrc(value: string): string {
    return value ? concatUrls(process.env.VUE_APP_CDN_URL, value) : "#";
  }

  formatDateTime(value: string): string {
    return value
      ? moment(value).format(process.env.VUE_APP_CONFIGS_DATETIME_FORMAT)
      : "";
  }

  onAdd() {
    this.current = { idLanguage: this.currentLanguage?.idLanguage || 0 };
    this.current[this.primary] = 0;
    if (this.enableReorder) {
      this.current.orderId = this.items.length + 1;
    }
    this.editableDialog = true;
  }

  onEdit(item: any) {
    this.current = { ...item };
    this.editableDialog = true;
  }

  onViewDetails(item: any) {
    console.log(item);
    // this.current = { ...item };
    // this.editableDialog = true;
  }

  onAction(action: GridAction, item: any) {
    this.$emit("action", new GridActionEvent(action.title, item));
  }

  onDelete(item: any) {
    this.current = item;
    this.confirmDialog = true;
  }

  async onConfirmEdit() {
    console.log(this.endpoint);
    if (this.isLoading) return;
    this.isLoading = true;
    if (this.isNew) {
      await this.configsService
        .Create(`${this.endpoint}`, this.current)
        .then(() => {
          (this.$refs.editForm as any).resetValidation();
          this.LoadItems(true);
        })
        .catch((error) => NotificationServiceBus.showError(error))
        .finally(() => {
          this.isLoading = false;
          if (this.createAnother) {
            this.onAdd();
          } else {
            this.editableDialog = false;
          }
        });
    } else {
      const id = this.current[this.primary];
      await this.configsService
        .Edit(`${this.endpoint}`, id, this.current)
        .then(() => {
          (this.$refs.editForm as any).resetValidation();
          this.LoadItems(true);
        })
        .catch((error) => NotificationServiceBus.showError(error))
        .finally(() => {
          this.isLoading = false;
          this.editableDialog = false;
        });
    }
  }

  async onConfirmDelete() {
    this.confirmDialog = false;
    if (this.isLoading) return;
    this.isLoading = true;
    const field = this.primary;
    const id = this.current[this.primary];

    await this.configsService
      .Remove(`${this.endpoint}`, id)
      .then(() => {
        this.items = this.items.filter(function (i: any) {
          return i[field] != id;
        });
      })
      .catch((error) => NotificationServiceBus.showError(error))
      .finally(() => (this.isLoading = false));
  }

  async onReorder(ids: number[]) {
    if (this.isLoading) return;
    this.items = [];
    this.isLoading = true;
    const data: any = { Ids: ids };
    await this.configsService
      .Redorder(`${this.endpoint}`, data)
      .then(() => {
        this.isLoading = false;
        this.LoadItems(false);
      })
      .catch((error) => NotificationServiceBus.showError(error));
  }

  getAvailableOptions(item: any): GridAction[] {
    const result: GridAction[] = [];
    if (this.actions) {
      this.actions.map((action: GridAction) => {
        if (action.visible && action.visible(item)) {
          result.push(action);
        }
        return action;
      });
    }
    return result;
  }

  containsValue(item: any, header: any): boolean {
    return this.items.some((element) => {
      const one = element[header.arg.array].some((el: any) => {
        return (
          el[header.value] === item &&
          el[header.arg.value] === header.arg.compareTo
        );
      });

      if (one) return true;
    });
  }

   get getCalc() {
    return  "-";
  }


  handleClick(value: any) {
    this.$emit("rowClick", value);
  }

  mounted() {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self = this;
    new Sortable(document.getElementsByTagName("tbody")[0], {
      handle: ".handle",
      draggable: ".drag-item",
      onEnd: function (ev: any) {
        const clone = [...self.filteredItems];
        const rowSelected = clone.splice(ev.oldDraggableIndex, 1)[0];
        clone.splice(ev.newDraggableIndex, 0, rowSelected);
        const field = self.primary;
        const ids: number[] = clone.map(function (t: any) {
          return t[field];
        });
        self.onReorder(ids);
      },
    });
  }
}
